module.exports = __webpack_public_path__ + "static/img/pingan.195795e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cooperation/pingan.png
// module id = CaIO
// module chunks = 0